module.exports = __webpack_public_path__ + "img/magasin-2.bf9d3838.jpg";